import {useEffect, useRef, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {register} from "../../api/client";

const personalDataPolicyUrl = `${process.env.PUBLIC_URL}/assets/documents/politika-obrabotki-personalnih-dannih.pdf`;

function Register({onAuthSuccess}) {
    const navigate = useNavigate();
    const confirmPasswordRef = useRef(null);
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [isLeaving, setIsLeaving] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!confirmPasswordRef.current) {
            return;
        }

        confirmPasswordRef.current.setCustomValidity(
            passwordConfirm && password !== passwordConfirm ? "Пароли не совпадают" : ""
        );
    }, [password, passwordConfirm]);

    async function handleSubmit(event) {
        event.preventDefault();
        setError("");
        setIsSubmitting(true);

        const formData = new FormData(event.currentTarget);

        try {
            const authResponse = await register({
                fullName: formData.get("fullName"),
                phone: formData.get("phone"),
                password: formData.get("password"),
                passwordConfirm: formData.get("passwordConfirm"),
                personalDataAgreement: formData.get("personalDataAgreement") === "on",
            });

            onAuthSuccess(authResponse, true);
            setIsLeaving(true);
            window.scrollTo({top: 0, behavior: "smooth"});

            setTimeout(() => {
                navigate("/");
                requestAnimationFrame(() => {
                    window.scrollTo({top: 0, behavior: "smooth"});
                });
            }, 240);
        } catch (requestError) {
            setError(requestError.message);
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <main className={isLeaving ? "auth-page auth-page-exiting" : "auth-page"}>
            <form className="auth-card" onSubmit={handleSubmit}>
                <Link className="auth-back" to="/">
                    <span aria-hidden="true">&lt;</span>
                    На главную
                </Link>

                <div className="auth-card-header">
                    <h1>Регистрация</h1>
                    <p>Создайте аккаунт для работы с сервисом.</p>
                </div>

                {error && <p className="auth-error">{error}</p>}

                <label>
                    ФИО пользователя
                    <input
                        type="text"
                        name="fullName"
                        autoComplete="name"
                        placeholder="Иванов Иван Иванович"
                        pattern="^[А-Яа-яЁёA-Za-z\s-]{5,80}$"
                        title="Введите ФИО буквами, без цифр и email"
                        required
                    />
                </label>

                <label>
                    Телефон
                    <input
                        type="tel"
                        name="phone"
                        autoComplete="tel"
                        inputMode="tel"
                        placeholder="+7 950 000 00 00"
                        pattern="^\+?[0-9\s()\-]{10,20}$"
                        title="Введите корректный номер телефона"
                        required
                    />
                </label>

                <label>
                    Пароль
                    <input
                        type="password"
                        name="password"
                        autoComplete="new-password"
                        placeholder="Придумайте пароль"
                        minLength="8"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        required
                    />
                </label>

                <label>
                    Повторите пароль
                    <input
                        ref={confirmPasswordRef}
                        type="password"
                        name="passwordConfirm"
                        autoComplete="new-password"
                        placeholder="Повторите пароль"
                        minLength="8"
                        value={passwordConfirm}
                        onChange={(event) => setPasswordConfirm(event.target.value)}
                        required
                    />
                </label>

                <label className="auth-checkbox">
                    <input type="checkbox" name="personalDataAgreement" required/>
                    <span>
                        Я согласен на обработку персональных данных и ознакомлен с{" "}
                        <a href={personalDataPolicyUrl} target="_blank" rel="noopener noreferrer">
                            Политикой в отношении обработки персональных данных
                        </a>
                        .
                    </span>
                </label>

                <button className="auth-submit" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Регистрируем..." : "Зарегистрироваться"}
                </button>

                <span className="auth-switch">
                    Уже есть аккаунт? <Link to="/login">Войти</Link>
                </span>
            </form>
        </main>
    );
}

export default Register;
